export var DEFAULT_PAGE_SIZE = 10;
export var ROW_HEIGHT = 30;
export var PLACE_HOLDER_HEIGHT = 40;
export var OVERSCAN_ROW_COUNT = 10;
export var MAX_MENU_LIST_HEIGHT = 300;